export const langsList = ['en', 'de', 'it', 'es', 'fr'];

// TODO: refactor without type assertion, or add comment
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const cacheStorage = localStorage.getItem(
  'mage-cache-storage',
) as string;

const configLang =
  typeof ENVIRONMENT_REGION !== 'undefined' ? ENVIRONMENT_REGION : null;
export const isEuEnv = configLang === 'EU';

export interface LocaleMessages {
  [key: string]: string;
}

export interface LocaleData {
  currentLocale: string;
  messages?: LocaleMessages;
}

// Fetch JSON file with language keys for Intl, if EU
export const getLocaleData = async (): Promise<LocaleData> => {
  try {
    let locales = {};
    const urlLang = document
      .querySelector('input[name=lang]:checked')
      ?.getAttribute('id')
      ?.replace('flag-', '');
    const storage = JSON.parse(cacheStorage);
    const storageLang =
      storage?.lang?.locale || localStorage.getItem('language');
    const localeRaw = urlLang || storageLang;
    const locale = langsList.includes(localeRaw) ? localeRaw : 'en';

    if (isEuEnv) {
      await fetch(`/media/translations/${locale}.json`)
        .then((response) => response.json())
        .then((data) => (locales = data))
        .catch((error) => {
          console.error(error);
        });
    }

    return { currentLocale: locale, messages: locales };
  } catch (e) {
    console.log(e);
    return { currentLocale: 'en', messages: {} };
  }
};

// Get Current User Language
export const getUserLang = (): 'en' | 'es' | 'fr' | 'de' | 'it' => {
  const urlLang = document
    .querySelector('input[name=lang]:checked')
    ?.getAttribute('id')
    ?.replace('flag-', '');
  const storage = JSON.parse(cacheStorage || '{}');
  const langRaw = urlLang || storage?.lang?.locale;
  return langsList.includes(langRaw) ? langRaw : 'en';
};

export const getApiPayloadLang = () => {
  return `${getUserLang()}-${ENVIRONMENT_REGION}`;
};

export const getLangLinkPrefix = () => {
  const lang = getUserLang();
  return isEuEnv ? `/${lang}` : '';
};

export const getStoreParam = () => {
  if (!isEuEnv) {
    return {};
  }

  return {
    ___store: getUserLang(),
  };
};
